import { render } from "./couponDetails.vue?vue&type=template&id=68c10ce8&scoped=true"
import script from "./couponDetails.vue?vue&type=script&lang=js"
export * from "./couponDetails.vue?vue&type=script&lang=js"

import "./couponDetails.vue?vue&type=style&index=0&id=68c10ce8&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c10ce8"]])

export default __exports__